import React, { useEffect, useState, useCallback } from 'react';
import { Route, Redirect } from "react-router-dom";
import ROUTES from "../routesConstants";
import { useDispatch, useMappedState } from 'redux-react-hook';
import { Auth } from 'aws-amplify';

function querystring(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
// const dispatch = useDispatch();
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default ({ component: C, props: cProps, ...rest }) => {
  const redirect = querystring("redirect");
  console.log("veamos cProps.isAuthenticated", cProps.isAuthenticated);
  console.log("redirect", redirect);

  const dispatch = useDispatch();
  const mapState = useCallback(
    state => ({
      isAuthenticated: state.user.isAuthenticated,
      userData: state.user.user
    }),
    []
  );
  // useEffect
  const getAuthenticated = async()=>{
    try{
      const session = await Auth.currentSession();
      console.log("session",session)
      setAuthenticated(true);
    }catch{
      console.log("No esta logeado")
      setAuthenticated(false);
    }
  }
  useEffect(() => {
    getAuthenticated();
  }, [])
  // const { isAuthenticated } = useMappedState(mapState);
  const { userData } = useMappedState(mapState);
  const [isAuthenticated,setAuthenticated]=useState(false);
  console.log("userData",userData)
  console.log("isAuthenticated",isAuthenticated)
  
  //user data debe ser undefined cuando no esta logeada
  return (
    <Route
      {...rest}
      render={props =>
        (!cProps.isAuthenticated) ? (
          <C {...props} {...cProps} />
        ) : (
          <Redirect
            to={
              redirect === "" || redirect === null ? ROUTES.ROOT_AUTH : redirect
            }
          />
        )
      }
    />
  );
};
